// extracted by mini-css-extract-plugin
export default {"arrow":"foudTXU67wA"};